// src/Paginas/Header.jsx
import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../Generales/index.css';

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const irAProductos = () => {
    setExpanded(false);

    // Si estamos en la página principal, hacer scroll
    if (location.pathname === '/') {
      const productos = document.getElementById('productos');
      if (productos) {
        productos.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // Si estamos en otra página, navegar a inicio y luego hacer scroll
      navigate('/');
      // Esperar a que la navegación complete y el DOM se actualice
      setTimeout(() => {
        const productos = document.getElementById('productos');
        if (productos) {
          productos.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  };

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      className="py-2 header-navbar"
    >
      <Container>

        {/* Logo - Redirige a inicio con React Router */}
        <Navbar.Brand as={Link} to="/">
          <img
            src="/Logos/logo-sin-fondo.png"
            alt="Lumiere TICA"
            height="145"
            className="d-inline-block align-top header-logo"
          />
        </Navbar.Brand>

        {/* Toggle para móvil */}
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          className="border-0"
        >
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>

        {/* Enlaces de navegación */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-lg-center gap-2">

            {/* Sobre Nosotros */}
            <Nav.Link
              as={Link}
              to="/sobre-nosotros"
              className="px-3 py-2 header-nav-link"
            >
              Sobre Nosotros
            </Nav.Link>

            {/* Comprar Ahora - Scroll hacia productos */}
            <Nav.Link
              as="button"
              onClick={irAProductos}
              className="px-4 py-2 rounded-pill header-cta-button"
            >
              <i className="fas fa-shopping-bag me-2"></i>
              Comprar Ahora
            </Nav.Link>

          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default Header;